import React, {useEffect, useState} from 'react';
import {Button, Grid, TextareaAutosize, Typography, useMediaQuery, useTheme} from "@mui/material";
import TextInput from "../../../../components/Admin/TextInput/TextInput";
import {getVisionInfoApi, updateVisionInfoApi} from "../../../../api/AdminApi";
import {successMessage} from "../../../../tools/messages";
import Loading from "../../../../components/Site/Loading/Loading";
import {fixStringToTextView} from "../../../../tools/helper";

const DashboardOurTarget = () => {
    const [lastData, setLastData] = useState({})
    const theme = useTheme();
    const isSmall = useMediaQuery(theme.breakpoints.between('xs', 'sm'));
    const [isLoading, setIsLoading] = useState(false);
    const fixTextareaSize = () => {
        let elm = document.querySelector("#text_area");
        elm.style.maxWidth = elm.offsetWidth + "px";
        elm.style.minWidth = elm.style.maxWidth;
    }

    const onSubmitHandler = async () => {
        try {
            await updateVisionInfoApi(lastData)
            successMessage('با موفقیت انجام شد');
        } catch (e) {
            //console.log(e)
        }
    }

    const getOurTarget = async () => {
        setIsLoading(true)
        try {
            const res = await getVisionInfoApi()
            setLastData(res?.data?.data)

        } catch (e) {
            // console.log(e)
        }
        setIsLoading(false)
    }

    useEffect(() => {
        getOurTarget()
        fixTextareaSize()
    }, [])
    if (isLoading) {
        return <Loading/>
    }
    return (

        <Grid sx={{
            border: {md: '1px solid #e5e0e01a', xs: 0},
            boxShadow: {md: 'rgba(17, 17, 26, 0.1) 0px 0px 16px', xs: 0},
            m: {md: 5, xs: 0},
            p: {md: 3, xs: 0},
            height: "90%"
        }}>
            <Grid sx={{display: "flex", flexDirection: {md: "row", xs: "column"}, alignItems: "center", mt: 3}}>
                <Typography sx={{marginRight: "auto", my: {md: 0, xs: 1}, minWidth: '65px'}}>عنوان اول</Typography>
                <TextInput value={lastData?.title1 ?? ""}
                           onChange={e => setLastData({...lastData, title1: e?.target?.value})}/>
            </Grid>
            <Grid sx={{display: "flex", flexDirection: {md: "row", xs: "column"}, alignItems: "center", my: 3}}>

                <Typography sx={{marginRight: "auto", my: {md: 0, xs: 1}, minWidth: '65px'}}>عنوان دوم</Typography>

                <TextInput value={lastData?.title2 ?? ""}
                           onChange={e => setLastData({...lastData, title2: e?.target?.value})}/>
            </Grid>
            <Grid sx={{display: "flex", flexDirection: {md: "row", xs: "column", sm: "column"}, my: 3}}>
                <Typography sx={{mb: {md: 0, xs: 1}, minWidth: '65px'}}>توضیحـات</Typography>


                <TextareaAutosize
                    value={fixStringToTextView(lastData?.description) ?? ''}
                    onChange={e => setLastData({...lastData, description: e?.target?.value})}
                    id={'text_area'}
                    minRows={15}
                    style={{
                        width: '100%',
                        height: '356px',
                        minHeight: '150px',
                        marginRight: isSmall ? 0 : 32,
                        padding: "12px",
                        fontSize: "0.875rem",
                        borderRadius: "10px 10px 0 10px",
                        borderColor: "#c0c0c1",
                        backgroundColor: "#F9F9FB",
                        '&:hover fieldset': {
                            borderColor: "red",
                        },

                    }} aria-label="empty textarea"
                    placeholder="متن خود را بنویسید"/>

            </Grid>
            <Grid sx={{textAlign: "center"}}>
                <Button
                    onClick={onSubmitHandler}
                    sx={{background: "#592EA9", padding: {sm: '15px 100px', xs: '8px 80px'}, borderRadius: "30px"}}
                    variant={"contained"}>ثبت
                    تغییرات</Button>
            </Grid>
        </Grid>
    );
};

export default DashboardOurTarget;